import VXETable from 'vxe-table'
// 创建一个简单的超链接渲染
VXETable.renderer.add('$Text', {
    // 默认显示模板
    renderDefault(h, renderOpts, params) {
        let { row, column } = params
        let { events, formatter, slotsDefault } = renderOpts
        return [<div class="celltext" onmousedown={(event) => events && events.onmousedown ? events.onmousedown(params, event) : null}
            onmouseover={() => events && events.onmouseover ? events.onmouseover(params) : null}
            onmouseout={() => events && events.onmouseout ? events.onmouseout(params) : null}
            onmouseup={(event) => events && events.onmouseup ? events.onmouseup(params, event) : null}
            onclick={(event) => events && events.onclick ? events.onclick(params, event) : null}
            oncontextmenu={(event) => events && events.oncontextmenu ? events.oncontextmenu(params, event) : null}>
            {slotsDefault ? slotsDefault({ row, column }) : formatter ? formatter(row) : row[column.property]}
        </div>]
    },
})